import './styles/main.css'
import './components/line-button.js'
import './components/direction-button.js'
import './components/line-list.js'
import './components/line-icon.js'
import './components/line_destination.js'
import './components/line-start.js'
import './components/line-list/line-list.js'
import './components/services-buttons.js'

// import './line.js'
import { setLines, lineServicesName } from './lines.js'
import { getLigne, getDirection } from './store/line-store.js'

import { lineSelected } from './utils/dom-utils.js'

/////////

addEventListener('DOMContentLoaded', () => {
	console.log('DOM fully loaded and parsed')

	fetch('/data/lines-data.json')
		.then((res) => res.json())
		.then((data) => {
			setLines(data.lignes)

			// let ligne = Lignes.find((l) => l.ligne === '11')

			// correctOrder.length = 0
			// for (let l of Object.values(ligne.data.aller)) {
			// 	correctOrder.push(l.name)
			// }
			// setup()
			lineSelected()
			document.getElementById('app').style.display = 'block'
			console.log(lineServicesName(getLigne()))
		})
})
